module.exports = __webpack_public_path__ + "img/flow-list-logo.1935acc7.svg";